/** Formateo homogéneo de valores en toda la pantalla de informes. */

import { getField } from './fieldsNew'
import { getSimboloActivo } from '../../utils/moneda'

const numberFormatters = new Map()

function formatter(decimals) {
  if (!numberFormatters.has(decimals)) {
    numberFormatters.set(
      decimals,
      new Intl.NumberFormat('es-ES', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })
    )
  }
  return numberFormatters.get(decimals)
}

export function formatNumber(value, decimals = 2) {
  if (value === null || value === undefined || value === '' || Number.isNaN(Number(value))) return '—'
  return formatter(decimals).format(Number(value))
}

/** Versión compacta para ejes y KPIs (9,5 M / 128 k). */
export function formatCompact(value) {
  const num = Number(value)
  if (!Number.isFinite(num)) return '—'
  const abs = Math.abs(num)
  if (abs >= 1_000_000_000) return `${formatNumber(num / 1_000_000_000, 1)} B`
  if (abs >= 1_000_000) return `${formatNumber(num / 1_000_000, 1)} M`
  if (abs >= 10_000) return `${formatNumber(num / 1000, 0)} k`
  return formatNumber(num, abs < 10 ? 1 : 0)
}

export function formatDate(value) {
  if (!value) return '—'
  const [year, month, day] = String(value).slice(0, 10).split('-')
  if (!year || !month || !day) return String(value)
  return `${day}/${month}/${year}`
}

/* Los campos de dinero llevan '€' como marca en fieldsNew. El importe llega del
   backend ya convertido a la moneda elegida, así que aquí solo se cambia el
   rótulo por el símbolo que toque. */
function unidad(unit) {
  return unit === '€' ? getSimboloActivo() : unit
}

/** Formatea una celda según los metadatos del campo. */
export function formatFieldValue(fieldKey, value) {
  const field = getField(fieldKey)
  if (!field) return value ?? '—'
  if (value === null || value === undefined || value === '') return '—'

  switch (field.type) {
    case 'number':
      return `${formatNumber(value, field.decimals ?? 2)}${field.unit ? ` ${unidad(field.unit)}` : ''}`
    case 'date':
      return formatDate(value)
    case 'boolean':
      return value ? 'Sí' : 'No'
    default:
      return String(value)
  }
}

/** Formatea el resultado de una métrica agregada. */
export function formatMetricValue(value, { unit, decimals = 0, compact = false } = {}) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—'
  const text = compact ? formatCompact(value) : formatNumber(value, decimals)
  return unit ? `${text} ${unidad(unit)}` : text
}
